import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { AdoProjectNameField } from './AdoProjectNameField';

export const AdoProjectNameFieldExtension = FormFieldBlueprint.make({
  name: 'ado-project-name-field',
  params: {
    field: async () =>
      createFormField({
        name: 'AdoProjectNameField',
        component: AdoProjectNameField,
      }),
  },
});
